import {
  ADD_NEW_USER,
  ADD_NEW_USER_ERROR,
  ADD_NEW_USER_SUCCESS,
  BULK_UPLOAD,
  BULK_UPLOAD_ERROR,
  BULK_UPLOAD_SUCCESS,
  UPDATE_NEW_USER,
  UPDATE_NEW_USER_ERROR,
  UPDATE_NEW_USER_SUCCESS,
  DELETE_USER_SUCCESS,
  DELETE_USER_ERROR,
  DELETE_USER_BYID,
  USER_ROLE_SUCCESS,
  USER_ROLE
} from "./actiontype";


import {
  USER_DATA,
  USER_DATA_ERROR,
  USER_DATA_SUCCESS,
  ALL_USER_DATA_SUCCESS,
} from "./actiontype";

export const getUsersList = (params, download,exportname) => {
  return {
    type: USER_DATA,
    payload: params,
    exports: download,
    exportname:exportname
  };
};
export const userListSuccess = (response) => {
  return {
    type: USER_DATA_SUCCESS,
    payload: response,
  };
};

export const allUserListSuccess = (response) => {
  return {
    type: ALL_USER_DATA_SUCCESS,
    payload: response,
  };
};

export const userListError = (erordata) => {
  return {
    type: USER_DATA_ERROR,
    payload: erordata,
  };
};
export const onAddnewUser = (params, callback) => {
  return {
    type: ADD_NEW_USER,
    payload: params,
    callback,
  };
};
export const onAddnewUserSuccess = (response) => {
  return {
    type: ADD_NEW_USER_SUCCESS,
    payload: response,
  };
};
export const onAddnewUserError = (erordata) => {
  return {
    type: ADD_NEW_USER_ERROR,
    payload: erordata,
  };
};
export const onupdateUser = (params, callback) => {
  return {
    type: UPDATE_NEW_USER,
    payload: params,
    callback,
  };
};
export const onupdateUserSuccess = (response) => {
  return {
    type: UPDATE_NEW_USER_SUCCESS,
    payload: response,
  };
};

export const onupdateUserError = (erordata) => {
  return {
    type: UPDATE_NEW_USER_ERROR,
    payload: erordata,
  };
};
export const onDeleteuser = (userId, callback) => {
  return {
    type: DELETE_USER_BYID,
    payload: userId,
    callback,
  };
};
export const onDeleteuserSuccess = (mess) => {
  return {
    type: DELETE_USER_SUCCESS,
    payload: mess,
  };
};

export const onDeleteuserError = (mess) => {
  return {
    type: DELETE_USER_ERROR,
    payload: mess,
  };
};
// export const postuploadData = (params, callback) => {
//   return {
//     type: BULK_UPLOAD,
//     payload: params,
//     callback,
//   };
// };
export const postuploadDataSuccess = (response) => {
  return {
    type: BULK_UPLOAD_SUCCESS,
    payload: response,
  };
};
export const postuploadDataError = (erordata) => {
  return {
    type: BULK_UPLOAD_ERROR,
    payload: erordata,
  };
};

export const getUserRoleSuccess = (response) => {
  return {
    type: USER_ROLE_SUCCESS,
    payload: response,
  };
};

export const fetchAllRole = () => {
  return {
    type: USER_ROLE,
  };
};



 